import type { ReactElement, SVGAttributes } from 'react';
import { getCurrentVendor } from '@studio/design-system/themes/vendor.js';
import type { Vendor } from '@studio/design-system/themes/vendor.js';

const logoMap: Record<Vendor, string> = {
  iris: '/assets/logo.png',
  ptzoptics: '/assets/ptzoptics/hive_icon.png'
};

const logoUrl = logoMap[getCurrentVendor()];

type Props = SVGAttributes<SVGSVGElement> & {
  theme?: 'primary' | 'success';
};

/** Download `<Icon>` component. */
export const Icon = (props: Props): ReactElement => {
  const { theme, ...svgProps } = props;

  return (
    <div className='relative my-24 h-[104px] w-[104px] overflow-visible'>
      <svg
        className='absolute'
        viewBox='0 0 105 105'
        width='104'
        height='104'
        style={{ zIndex: 1 }}
        {...svgProps}
      >
        <rect className='fill-dark' height='105' rx='16' width='105' y='0' />
      </svg>

      <img
        alt='Iris Studio'
        className='absolute left-[15px] top-[15px]'
        height={74}
        src={logoUrl}
        width={74}
        style={{ zIndex: 2 }}
      />

      <svg
        style={{
          bottom: '-25px',
          height: '50px',
          position: 'absolute',
          right: '-25px',
          width: '50px',
          zIndex: 10
        }}
        viewBox={theme === 'success' ? '0 0 66 66' : '0 0 50 50'}
      >
        {theme === 'success' ? (
          <>
            <g filter='url(#filter0_d_16795_45843)'>
              <rect
                x='8'
                y='8'
                width='50'
                height='50'
                rx='25'
                fill='#29CC6A'
                shapeRendering='crispEdges'
              />
              <path
                d='M43.6666 25L28.9999 39.6667L22.3333 33'
                stroke='#F6F7F9'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
                fill='transparent'
              />
            </g>
            <defs>
              <filter
                id='filter0_d_16795_45843'
                x='0'
                y='0'
                width='66'
                height='66'
                filterUnits='userSpaceOnUse'
                colorInterpolationFilters='sRGB'
              >
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix
                  in='SourceAlpha'
                  type='matrix'
                  values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                  result='hardAlpha'
                />
                <feOffset />
                <feGaussianBlur stdDeviation='4' />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0' />
                <feBlend
                  mode='normal'
                  in2='BackgroundImageFix'
                  result='effect1_dropShadow_16795_45843'
                />
                <feBlend
                  mode='normal'
                  in='SourceGraphic'
                  in2='effect1_dropShadow_16795_45843'
                  result='shape'
                />
              </filter>
            </defs>
          </>
        ) : (
          <>
            <path
              className='fill-success'
              d='M25,0L25,0c13.8,0,25,11.2,25,25l0,0c0,13.8-11.2,25-25,25l0,0C11.2,50,0,38.8,0,25l0,0C0,11.2,11.2,0,25,0z'
            />
            <path
              className='fill-light'
              d='M16.1,23.6c-0.5-0.5-0.5-1.3,0-1.8c0.5-0.5,1.3-0.5,1.8,0l5.9,5.9V12c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2
v15.6l5.9-5.9c0.5-0.5,1.3-0.5,1.8,0c0.5,0.5,0.5,1.3,0,1.8l-8,8c0,0,0,0,0,0s0,0,0,0l0,0h0c0,0,0,0,0,0c-0.1,0.1-0.3,0.2-0.4,0.3h0
c-0.1,0.1-0.3,0.1-0.5,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0c-0.2,0-0.3,0-0.5-0.1c-0.1-0.1-0.3-0.1-0.4-0.3
c0,0,0,0,0,0v0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0h0l0,0c0,0,0,0,0,0s0,0,0,0L16.1,23.6z M37,34.8H13
c-0.7,0-1.2,0.6-1.2,1.2s0.6,1.2,1.2,1.2h24c0.7,0,1.2-0.6,1.2-1.2S37.7,34.8,37,34.8z'
            />
          </>
        )}
      </svg>
    </div>
  );
};
